import React from 'react'
import './Contact.css'
import  { useEffect, useRef } from "react";
import lottie from "lottie-web";
import { faEnvelope, faMailReply, faMessage, faPhone, faUser } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGithubSquare, faGoogle, faWhatsappSquare } from '@fortawesome/fontawesome-free-brands';
import contactimg from '../../../images/hand-contact.png'
function Contact() {
    const container = useRef(null);

    useEffect(() => {
        lottie.loadAnimation({
          container: container.current,
          renderer: "svg",
          loop: true,
          autoplay: true,
          animationData: require("../../../animation/contact-1.json")
        });
    
        
        return () => {
          lottie.destroy();
        };
      }, []);


      const img = useRef(null);
      useEffect(()=> {
        lottie.loadAnimation({
            container:img.current,
            renderer:'svg',
            loop:true,
            autoplay:true,
            animationData: require("../../../animation/contact-2.json")
        })
      })
      
      
  return (
    <>
        <div className="contact" id='contact'>
            <div className="container">
                <h1 data-aos="zoom-in" data-aos-duration="2500">Contact</h1>
                <div className="img" ref={container}></div>

                <div className="contact-container" data-aos="zoom-in" data-aos-duration="2500">
                    <div className="left-box">
                        <div className="contact-info">
                            <h2>get in touch</h2>
                            <p>Fill out the form and i will get back to you ASAP.</p>
                            <div className="image-left" ref={img}></div>
                        </div>
                        <div className="form">
                            <form action="">
                                <div className="form-wrapper">
                                    <div className="input-section-title">
                                        <label> Name:*</label>
                                    </div>
                                    <div className="input-section-info">
                                        <FontAwesomeIcon icon={faUser} />
                                        <input type="text" placeholder='ex: Eslam Elhadidy' required />
                                    </div>
                                </div>
                                <div className="form-wrapper">
                                    <div className="input-section-title">
                                        <label>Email:*</label>
                                    </div>
                                    <div className="input-section-info">
                                        <FontAwesomeIcon icon={faEnvelope} />
                                        <input type="email" placeholder='ex: elhadidii624@gmail.com' required />
                                    </div>
                                </div>
                                <div className="form-wrapper">
                                    <div className="input-section-title">
                                        <label>Message:*</label>
                                    </div>
                                    <div className="input-section-info">
                                        <FontAwesomeIcon icon={faMessage} />
                                        <textarea name="" id="" cols="30" rows="2" placeholder='ex: work toghter!' required></textarea>
                                    </div>
                                </div>
                                <a href="mailto:elhadidii624@gmail.com" target='_blank' rel="noreferrer">Send</a>
                            </form>
                        </div>
                    </div>
                    <div className="right-box">
                            <div className="contact-heading">
                                <h2>contact info</h2>
                                <p>Let’s level up your brand together.</p>
                            </div>
                            <a className='number' href="https://api.whatsapp.com/send?phone=201060088542">
                                <FontAwesomeIcon icon={faPhone} />
                                <span>+201060088542</span>
                            </a>
                            <a className='gmail' href="mailto:elhadidii624@gmail.com" target='_blank' rel="noreferrer">
                                <FontAwesomeIcon icon={faMailReply} />
                                <span>elhadidii624@gmail.com</span>
                            </a>
                            <div className="contacts">
                                <ul>
                                    <li><a href="https://api.whatsapp.com/send?phone=201060088542" target='_blank' rel="noreferrer"><FontAwesomeIcon icon={faWhatsappSquare} /></a></li>
                                    <li><a href="https://github.com/IslamElhadidy" target='_blank' rel="noreferrer"><FontAwesomeIcon icon={faGithubSquare} /></a></li>
                                    <li><a href='mailto:elhadidii624@gmail.com' target='_blank' rel="noreferrer"><FontAwesomeIcon icon={faGoogle} /></a></li>
                                </ul>
                            </div>
                            <div className="hand-contact">
                                <img src={contactimg}alt={contactimg}/>
                            </div>
                    </div>
                </div>
            </div>
        </div>
    </>
  )
}

export default Contact